function ErrorApi() {
  return (
    <div className="cart cart--empty">
      <h2>Error api !</h2>
      <p>
        I am sorry
        <br />
        do not today
      </p>
    </div>
  );
}

export default ErrorApi;
